














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import _ from "lodash";
import SimpleText from "front-component/components/SimpleText.vue";
import { Document } from "../Document.vue";

@Component({ components: { SimpleText } })
export default class DocumentInsertionQuotationNumber extends Vue {
    @Prop() public document!: Document;

    public get uniqueQuotationNumbers(): string[] {
        return _.uniq(this.document.insertions.map((insertion) => insertion.quotationNumber));
    }

    public static getNeededFields(): string[] {
        return [];
    }
}
